(function (root, factory) {
  const api = factory();

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }

  root.WddEcomailNewsletter = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';

  function buildPayload(options) {
    const source = options.source || 'shopify-newsletter';

    return {
      email: options.email,
      language: options.language,
      list_key: options.listKey,
      locale: options.locale,
      source,
      subscriber_data: {
        email: options.email,
        language: options.language,
        list_key: options.listKey,
        source
      }
    };
  }

  return { buildPayload };
});
